"use strict";
exports.__esModule = true;
exports.chart_color_orange_200 = {
  "name": "--pf-v5-chart-color-orange-200",
  "value": "#ef9234",
  "var": "var(--pf-v5-chart-color-orange-200, #ef9234)"
};
exports["default"] = exports.chart_color_orange_200;